module.exports = {
	"CATEGORIES": {
		"CARDS_NEWS": "v2-cards-news",
		"CARDS_CUSTOM": "v2-cards-custom",
		"CARDS_ONLINE_RESOURCE": "v2-cards-online-resource",
		"CARDS_BLOG": "v2-cards-blog",
		"CARDS_LIST": "v2-cards-list",
		"CARDS_EVENT": "v2-cards-event",
		"CARDS_COMMENT": "v2-cards-comment",
		"CARDS_QUOTE": "v2-cards-quote",
		"CARDS_POLL": "v2-cards-poll",
		"CARDS_TWITTER": "v2-cards-twitter",
		"CARDS_INSTAGRAM": "v2-cards-instagram",
		"CAROUSELS": "v2-carousels",
		"ACTIVITY_FEEDS": "v2-feeds-activity",
		"NOTIFICATION_FEEDS": "v2-feeds-notification",
		"COMMUNITY_FEEDS": "v2-feeds-community",
		"CONTENT_FEEDS": "v2-feeds-content",
		"HERO_BLOCK": "v2-hero",
		"NAVIGATION": "v2-navigation",
		"WEB_TAXONOMIES": "v2-web-taxonomies",
		"PAGE_INTERACTIONS": "v2-page-interactions",
		"HOLDS": "v2-holds",
		"DIGITAL_HOLDS": "v2-holds-digital",
		"SHELVES": "v2-shelves",
		"RATINGS": "v2-ccc-ratings",
		"COMMENTS": "v2-ccc-comments",
		"TAGS": "v2-ccc-tags",
		"QUOTATIONS": "v2-ccc-quotations",
		"VIDEOS": "v2-ccc-videos",
		"SIMILAR_TITLES": "v2-ccc-similar-titles",
		"AVAILABILITY": "v2-availability",
		"CHECKOUTS": "v2-checkouts",
		"SEARCH": "v2-search",
		"SEARCH_RESULTS": "v2-search-results",
		"BROADEN_SEARCH": "v2-search-broaden",
		"EMPTY_SEARCH_RESULTS": "v2-search-empty",
		"LISTS": "v2-lists",
		"FEATURE_IN_CATALOG": "v2-feature-in-catalog",
		"WHILE_YOU_WAIT": "v2-while-you-wait",
		"FEES": "v2-fees",
		"PATRON_PREFERENCES": "v2-patron-preferences",
		"BIB_FORMAT_CHOOSER": "v2-bib-format-chooser"
	},
	"ACTIONS": {
		"CLICK_TITLE": "v2-title-click",
		"CLICK_IMAGE": "v2-image-click",
		"PLAY_VIDEO": "v2-video-play",
		"CLICK_LINK": "v2-link-click",
		"OUTBOUND_LINK_CLICK": "v2-outbound-link-click",
		"PAGE_SCROLL": "v2-scroll",
		"SUBMIT_FORM": "v2-submit",
		"INTERACT_WITH_CONTAINER": "v2-container-interaction",
		"VIEW": "v2-view",
		"DOWNLOAD_A_FILE": "v2-file-download",
		"ADD_CONTENT": "v2-add",
		"EDIT_ITEM": "v2-edit",
		"REMOVE_CONTENT": "v2-remove",
		"MOVE_CONTENT": "v2-move",
		"ADD_ITEM_TO_CONTENT": "v2-add-item",
		"REMOVE_ITEM_FROM_CONTENT": "v2-remove-item",
		"TOGGLE_OPTION": "v2-toggle",
		"TOGGLE_PRIVACY": "v2-toggle-privacy",
		"TOGGLE_VISIBILITY": "v2-toggle-visibility",
		"TOGGLE_OWNERSHIP": "v2-toggle-i-own-this",
		"LIKE_ITEM": "v2-like",
		"DISLIKE_ITEM": "v2-dislike",
		"PAY_FINE": "v2-pay",
		"RENEW_ITEM": "v2-renew",
		"PLACE_HOLD": "v2-place",
		"CANCEL_HOLD": "v2-cancel",
		"PAUSE_HOLD": "v2-pause",
		"RESUME_HOLD": "v2-resume"
	},
	"LABELS": {
		"CONTAINER_TITLE": "title",
		"CONTAINER_FWD_ARROW": "forward-arrow",
		"CONTAINER_BWD_ARROW": "backward-arrow",
		"CONTAINER_DOT_INDICATORS": "dot-indicators",
		"CONTAINER_FWD_SWIPE": "forward-swipe",
		"CONTAINER_BWD_SWIPE": "backward-swipe",
		"CONTAINER_EXPAND": "expand",
		"CONTAINER_COLLAPSE": "collapse",
		"CONTAINER_NEXT_PAGE": "next-page",
		"CONTAINER_PREV_PAGE": "previous-page",
		"CONTAINER_TAB": "tab",
		"CONTAINER_PAGE": "page-{}",
		"CONTAINER_VIEW_ALL": "all-results",
		"CONTAINER_READ_MORE": "read-more",
		"BIB_TITLE": "bib-title",
		"BIB_COVER": "bib-cover",
		"BIB_AUTHOR": "bib-author",
		"REPORT_THIS": "report-this",
		"TAKE_THE_POLL": "take-the-poll",
		"SKIP_TO_RESULTS": "skip-to-results"
	},
	"EVENTS": {
		"OPT_IN": "bc.userOptIn",
		"OPT_OUT": "bc.userOptOut",
		"BROADEN_SEARCH": "bc.broadenSearch",
		"SEARCH_RESULTS": "bc.searchResults",
		"DYM_SEARCH_RESULT_IMPRESSION": "bc.dymSearchResultImpression",
		"DYM_SEARCH_RESULT_CLICK": "bc.dymSearchResultClick",
		"EMPTY_SEARCH_RESULT": "bc.emptySearchResult",
		"PLACE_HOLD": "bc.placeHold",
		"CANCEL_HOLD": "bc.cancelHold",
		"PAUSE_HOLD": "bc.pauseHold",
		"RESUME_HOLD": "bc.resumeHold",
		"ADD_TO_SHELF": "bc.addToShelf",
		"REMOVE_FROM_SHELF": "bc.removeFromShelf",
		"MOVE_TO_SHELF": "bc.moveToShelf",
		"ADD_RATING": "bc.addRating",
		"EDI_TRATING": "bc.editRating",
		"REMOVE_RATING": "bc.removeRating",
		"ADD_COMMENT": "bc.addComment",
		"EDIT_COMMENT": "bc.editComment",
		"REMOVE_COMMENT": "bc.removeComment",
		"ADD_TAG": "bc.addTag",
		"REMOVE_TAG": "bc.removeTag",
		"ADD_VIDEO": "bc.addVideo",
		"REMOVE_VIDEO": "bc.removeVideo",
		"EDIT_VIDEO": "bc.editVideo",
		"CHECK_AVAILABILITY": "bc.checkAvailability",
		"FORMAT_CHOOSER_SELECTION": "bc.bibFormatChooserSelection",
		"RENEWCHECKOUT": "bc.renewCheckout",
		"TOGGLE_I_OWN_THIS": "bc.toggleIOwnThis",
		"TOGGLE_PRIVACY": "bc.togglePrivacy",
		"ADD_QUOTATION": "bc.addQuotation",
		"EDIT_QUOTATION": "bc.editQuotation",
		"REMOVE_QUOTATION": "bc.removeQuotation",
		"ADD_SIMILAR_TITLE": "bc.addSimilarTitle",
		"REMOVE_SIMILAR_TITLE": "bc.removeSimilarTitle",
		"CARD_CLICK": "bc.cardClick",
		"FORM_SUBMISSION": "bc.formSubmission",
		"FILE_DOWNLOAD": "bc.fileDownload",
		"OUTBOUND_LINK": "bc.outboundLinkClick"
	},
	"CUSTOM_DIMENSIONS": {
		"DIMENSION_MAP": {
			"LIBRARY_ID": "bc.libraryId",
			"SITE_ID": "bc.siteId",
			"BIBLIOWEB_LIBRARY": "bc.cmsEnabled",
			"CONTAINER_NAME": "payload.gtmContainerName",
			"CONTENT_TYPE": "payload.gtmContentType",
			"CONTENT_CREATOR": "payload.gtmContentCreator",
			"CREATOR_TYPE": "payload.gtmCreatorType",
			"CARD_TITLE": "payload.gtmCardTitle"
		},
		"CONTENT_TYPES": {
			"LIST": "list",
			"EVENT": "event",
			"BLOG": "blog",
			"NEWS": "news",
			"FAQ": "faq",
			"TWITTER": "tweet",
			"INSTAGRAM": "instagram",
			"POLL": "poll",
			"ONLINE_RESOURCE": "online-resource",
			"VIDEO": "video",
			"BIB": "bib",
			"COMMENT": "comment",
			"QUOTE": "quote",
			"BIB_TAG": "bib-tag",
			"SUMMARY": "summary",
			"FORM": "form"
		},
		"CREATOR_TYPES": {
			"LIBRARY_STAFF": "library-staff",
			"LIBRARY_PATRON": "library-patron",
			"EXTERNAL_STAFF": "external-staff",
			"EXTERNAL_PATRON": "external-patron",
			"BARCODELESS_USER": "barcodeless-user"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/constants-analytics/lib/constants.json
// module id = 714
// module chunks = 1